/* Zen & Zip — cart-page payment button hierarchy.
   Shopify bundles Shop Pay + Amazon Pay + PayPal + Google Pay into one
   <shopify-accelerated-checkout-cart> widget it controls; Liquid can't
   split or reorder them. Each wallet button is its own self-contained
   custom element (own access-token/wallet-params attributes) though, so
   once Shopify's script populates them we pull everything except Shop
   Pay out into a collapsed "Other payment methods" accordion, leaving:
   Checkout -> Shop Pay -> divider -> accordion. Shop Pay itself is never
   moved, only repositioned relative to (untouched) -- the goal is to
   keep the express, highest-intent options up front and demote the
   rarely-used wallets without touching their working DOM state. */
(function () {
  'use strict';

  var WALLET_SELECTOR = 'shop-pay-wallet-button, shopify-amazon-pay-button, shopify-paypal-button, shopify-google-pay-button, shopify-apple-pay-button';

  function walletChildren(accel) {
    return Array.prototype.filter.call(accel.children, function (k) {
      return k.matches(WALLET_SELECTOR);
    });
  }

  function extractOthers(accel) {
    var kids = walletChildren(accel);
    var shopPay = null;
    var others = [];
    kids.forEach(function (k) {
      if (k.tagName === 'SHOP-PAY-WALLET-BUTTON') shopPay = k;
      else others.push(k);
    });
    return { shopPay: shopPay, others: others };
  }

  function buildDivider() {
    var div = document.createElement('div');
    div.className = 'zz-cart-payment-divider';
    var span = document.createElement('span');
    span.textContent = 'or';
    div.appendChild(span);
    return div;
  }

  function buildAccordion(buttons) {
    var details = document.createElement('details');
    details.className = 'zz-cart-other-payments';
    var summary = document.createElement('summary');
    summary.textContent = 'Other payment methods';
    details.appendChild(summary);
    var body = document.createElement('div');
    body.className = 'zz-cart-other-payments__body';
    buttons.forEach(function (b) {
      body.appendChild(b);
    });
    details.appendChild(body);
    return details;
  }

  function shrinkToFit(container, accel) {
    // Shopify's widget reserves layout space per configured wallet
    // (originally ~256px for 4 stacked buttons) inside its closed
    // shadow root, independent of how many light-DOM children are
    // actually left after extraction -- removing 3 of 4 elements alone
    // leaves a large empty gap below Shop Pay. Clip both the host and
    // its container down to Shop Pay's own real rendered height once
    // layout has settled, rather than fighting the shadow-internal
    // sizing with plain CSS.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var shopPay = accel.querySelector('shop-pay-wallet-button');
        var h = shopPay ? shopPay.getBoundingClientRect().height : 0;
        if (h > 0) {
          accel.style.height = h + 'px';
          accel.style.overflow = 'hidden';
          container.style.height = h + 'px';
          container.style.overflow = 'hidden';
        }
      });
    });
  }

  function process(container) {
    if (container.hasAttribute('data-zz-processed')) return;
    var accel = container.querySelector('shopify-accelerated-checkout-cart');
    if (!accel || !walletChildren(accel).length) return;

    container.setAttribute('data-zz-processed', '');

    var split = extractOthers(accel);

    // Real Shop Pay Installments messaging for the current cart total,
    // rendered by sections/cart.liquid via an isolated {% form 'cart' %}
    // block (payment_terms needs a Liquid form object, which the page's
    // own raw <form> doesn't provide). Reposition it directly under
    // Shop Pay rather than wherever it happened to render in the flow.
    var termsEl = container.parentElement.querySelector('[data-zz-shop-pay-terms]');
    var anchor = container.nextSibling;
    if (termsEl && split.shopPay) {
      termsEl.classList.add('zz-shop-pay-terms');
      container.parentElement.insertBefore(termsEl, anchor);
      anchor = termsEl.nextSibling;
    }

    if (split.others.length) {
      var divider = buildDivider();
      var accordion = buildAccordion(split.others);
      container.parentElement.insertBefore(divider, anchor);
      container.parentElement.insertBefore(accordion, anchor);
    }

    shrinkToFit(container, accel);
  }

  function watch(container) {
    if (container.__zzWatching) return;
    container.__zzWatching = true;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var accel = container.querySelector('shopify-accelerated-checkout-cart');
      if (accel && walletChildren(accel).length) {
        clearInterval(timer);
        process(container);
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  function scan() {
    document.querySelectorAll('.dynamic-checkout-buttons').forEach(watch);
  }

  function init() {
    scan();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        scan();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
